import { useMemo } from 'react'

import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'

import useInfinitePagination from './useInfinitePagination'
import { SCORE_TYPES, FILTER_TYPES } from '../constants'

const filterItemsByType = (items, filterType) => {
  const positiveItems = []
  const negativeItems = []
  const commentsItems = []

  items.forEach((item) => {
    if (item.score === SCORE_TYPES.POSITIVE) {
      positiveItems.push(item)
    } else if (item.score === SCORE_TYPES.NEGATIVE) {
      negativeItems.push(item)
    } else if (item.score !== SCORE_TYPES.NEUTRAL) {
      commentsItems.push(item)
    }
  })

  let filteredItems = []
  switch (filterType) {
    case FILTER_TYPES.POSITIVE:
      filteredItems = positiveItems
      break
    case FILTER_TYPES.NEGATIVE:
      filteredItems = negativeItems
      break
    default:
      filteredItems = commentsItems
      break
  }

  return filteredItems
}

const useItemFiltering = (
  initialComments = [],
  initialRatings = [],
  filterBy = FILTER_TYPES.COMMENTS,
  counts = { comments: 0, positive: 0, negative: 0 },
  hasMoreComments = false,
  hasMoreRatings = false
) => {
  const pageConfig = usePageConfig()
  const productSlug = pageConfig?.product?.slug

  // Prepare initial data for the current filter
  const initialFilteredItems = useMemo(() => {
    const commentsWithType = initialComments.map(comment => ({ ...comment, itemType: 'comment' }))
    const ratingsWithType = initialRatings.map(rating => ({ ...rating, itemType: 'rating' }))

    return filterItemsByType([...commentsWithType, ...ratingsWithType], filterBy)
  }, [initialComments, initialRatings, filterBy])

  // Determine which hasMore flag to use based on filter type
  const hasMoreData = useMemo(() => {
    switch (filterBy) {
      case FILTER_TYPES.COMMENTS:
        return hasMoreComments
      case FILTER_TYPES.POSITIVE:
      case FILTER_TYPES.NEGATIVE:
        return hasMoreRatings
      default:
        return false
    }
  }, [filterBy, hasMoreComments, hasMoreRatings])

  const {
    items: displayedItems,
    hasMore,
    isLoadingMore,
    error,
    loadNextPage,
  } = useInfinitePagination(initialFilteredItems, filterBy, productSlug, hasMoreData)

  return {
    displayedItems,
    counts,
    hasMore,
    isLoadingMore,
    error,
    loadNextPage,
  }
}

export default useItemFiltering
